export default __webpack_public_path__ + "static/5. Efficient Staff Management 1-069e27eb7a3989795ed45bdcf291ae78.png";